import isArray from 'lodash-es/isArray';
import merge from 'lodash-es/merge';
import get from 'lodash-es/get';
import cloneDeep from 'lodash-es/cloneDeep';
import getDefaultStyle from '../css/defaultStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import updateClass from '../css/updateClass';
import 'nouislider/distribute/nouislider.css';

const cssClass = [
  {
    selector: '.noUi-handle',
    properties: {
      background: '${schemeForeground}',
      border: '1px solid rgba(0,0,0,0.3)',
      boxShadow:
        'inset 0 0 2px ${schemeForeground}, inset 0 1px 7px rgba(0,0,0,0.3), 0 3px 6px 3px rgba(0,0,0,0.3)',
    },
  },
  {
    selector: '.noUi-connects',
    properties: {
      boxShadow: '0px 0px 6px 0px ${schemeBackground} inset',
    },
  },
  {
    selector: '.noUi-connect',
    properties: {
      backgroundColor: '${schemeBackground}',
      boxShadow: 'inherit',
    },
  },
  {
    selector: '&.noUi-horizontal .noUi-handle',
    properties: {
      height: '100%',
      top: '-6px',
    },
  },
  {
    selector: '&.noUi-horizontal .noUi-origin',
    properties: {
      height: 'calc(100% + 12px)',
    },
  },
  {
    selector: '&.noUi-horizontal .noUi-handle:before,&.noUi-horizontal  .noUi-handle:after ',
    properties: {
      height: '50%',
      top: '25%',
      // boxShadow: '0 0 3px rgba(0,0,0,0.3)',
      opacity: 0.3,
      background: '${schemeShade}',
    },
  },
  {
    selector: '&.noUi-vertical .noUi-handle',
    properties: {
      width: '100%',
      left: '-6px',
    },
  },
  {
    selector: '&.noUi-vertical .noUi-origin',
    properties: {
      width: 'calc(100% + 12px);',
    },
  },
  {
    selector: '&.noUi-vertical .noUi-handle:before,&.noUi-vertical  .noUi-handle:after ',
    properties: {
      width: '50%',
      left: '25%',
      // boxShadow: '0 0 3px rgba(0,0,0,0.3)',
      opacity: 0.3,
      background: '${schemeShade}',
    },
  },
  {
    selector: '.noUi-tooltip',
    properties: {
      fontSize: 'calc(${schemeFontSize} * 0.75)',
      backgroundColor: '${schemeSysBackground}',
      boxShadow: '0px 0px 4px 0px ${schemeBackground}',
      color: '${schemeForeground}',
      border: 'none',
      borderRadius: '4px',
    },
  },
  {
    selector: '.noUi-pips',
    properties: {
      fontSize: 'calc(${schemeFontSize} * 0.75)',
      opacity: 0.5,
      pointerEvents: 'none',
      // backgroundColor: '${schemeSysBackground}',
      color: '${schemeForeground}',
    },
  },
  {
    selector: '.noUi-marker',
    properties: {
      backgroundColor: '${schemeForeground}',
    },
  },
  {
    selector: '.noUi-value-horizontal',
    properties: {
      lineHeight: 1,
      top: '22px',
    },
  },
];

const cssClassFlat = [
  {
    selector: '.noUi-handle',
    properties: {      
      boxShadow:
        'inset 0 0 2px ${schemeForeground}',
    },
  },
  {
    selector: '.noUi-connects',
    properties: {
      boxShadow: 'none',
      backgroundColor: '${schemeShade}',
      
    },
  },
  {
    selector: '.noUi-connect',
    properties: {
      
    },
  },
  {
    selector: '&.noUi-horizontal .noUi-handle',
    properties: {      
    },
  },
  {
    selector: '&.noUi-horizontal .noUi-origin',
    properties: {      
    },
  },
  {
    selector: '&.noUi-horizontal .noUi-handle:before,&.noUi-horizontal  .noUi-handle:after ',
    properties: {      
    },
  },
  {
    selector: '&.noUi-vertical .noUi-handle',
    properties: {      
    },
  },
  {
    selector: '&.noUi-vertical .noUi-origin',
    properties: {
    },
  },
  {
    selector: '&.noUi-vertical .noUi-handle:before,&.noUi-vertical  .noUi-handle:after ',
    properties: {      
    },
  },
  {
    selector: '.noUi-tooltip',
    properties: {
      boxShadow: 'none',      
      border: '1px solid rgba(255,255,255,0.5)',
      borderRadius: '2px',
    },
  },
  {
    selector: '.noUi-pips',
    properties: {      
    },
  },
  {
    selector: '.noUi-marker',
    properties: {
      
    },
  },
  {
    selector: '.noUi-value-horizontal',
    properties: {
      
    },
  },
];

updateClass(
  'io-range-default-style',
  updateStyleByRef(cloneDeep(cssClass), lookAndFeel()),
  '.io-range-default'
);

updateClass(
  'io-range-default-style-flat',
  updateStyleByRef(cloneDeep(cssClassFlat), lookAndFeel()),
  '.io-range-default-flat'
);

const cssStyle = {
  normal: merge({}, getDefaultStyle(), {
    position: 'absolute',
    transitionProperty: 'all',
    transitionDuration: '${schemeAnimationDuration}',
    transitionTimingFunction: 'ease',
    transitionDelay: '0s',
    boxSizing: 'border-box',
    top: '8px',
    left: '8px',
    width: '128px',
    height: '8px',
    display: 'inline-block',
    margin: '0px',
  }),
};

function createElement(control) {
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  const element = document.createElement('div');
  element.classList.add('io-range-default');
  element.classList.add('controls');
  if(design=='flat'){
    element.classList.add('io-range-default-flat');
  }

  return element;
}

const options = {
  orientation: 'horizontal',
  start: [50],
  connect: [true, false],
  range: {
    max: 100,
    min: 0,
  },
  step: 0,
  direction: 'ltr',
  margin: 0,
  padding: 0,
  limit: undefined,
  tooltips: false,
  behaviour: 'tap',
};
const sliderKeys = [
  'start',
  'range',
  'step',
  'connect',
  'margin',
  'limit',
  'padding',
  'orientation',
  'direction',
  'tooltips',
  'behaviour',
  'pips',
];
const sliderUpdateKeys = [
  'start',
  'margin',
  'padding',
  'limit',
  'step',
  'range',
  'pips',
  'tooltips',
];

function normalize(options) {
  if (!isArray(options.start)) {
    options.start = [options.start];
  }

  if (options.connect.length > options.start.length + 1) {
    options.connect = options.connect.slice(0, options.start.length + 1);
  } else {
    while (options.connect.length < options.start.length + 1) {
      options.connect.push(false);
    }
  }
}

export default {
  cssClass,
  cssClassFlat,
  cssStyle,
  createElement,
  options,
  sliderKeys,
  sliderUpdateKeys,
  normalize,
};
